<template>
  <iframe
    class="cmiframe"
    frameborder="0"
    :src="codemonekyUrl"
  >
  </iframe>
</template>

<script>
import { saveCMStars } from '../request/cm-ser';
import { getUserToken } from '../request/userinfo';
import comUrl from '../utils/uri';

export default {
  name: 'codemonkehy',
  data() {
    return {
      projectId: null,
    };
  },

  computed: {
    codemonekyUrl() {
      const url = comUrl.cmUrl;
      const token = getUserToken();
      return `${url}/${this.projectId}?token=${token}`;
    },
  },

  methods: {
    receiveMessage(event) {
      try {
        let { data } = event;
        data = typeof data === 'string' ? JSON.parse(data) : data;
        const {
          type,
          ...payload
        } = data;

        if (typeof type === 'undefined') return;

        const method = type.replace(/_(\w)/g, (i, s) => s.toUpperCase());
        if (typeof this[method] === 'function') this[method](payload);
      } catch (err) {
        console.log(err);
      }
    },

    async cmRun(data) {
      await saveCMStars({
        projectId: this.projectId,
        code: data.code,
        stars: data.stars,
        time: data.time || 0,
      });
    },

    cmFinish() {
      this.$router.go(-1);
    },
  },

  created() {
    const { projectId } = this.$route.query;
    this.projectId = projectId;

    window.addEventListener('message', this.receiveMessage, false);
  },

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage, false);
  },
};
</script>

<style lang='less' scoped>
.cmiframe {
  width: 100%;
  height: 100%;
}
</style>
